import { render, staticRenderFns } from "./PaymentsHelp.vue?vue&type=template&id=01a2ec92"
import script from "./PaymentsHelp.vue?vue&type=script&lang=js"
export * from "./PaymentsHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports